import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User triggered navigation to the canvases list page from workspace search',
  name: 'canvas_search_shortcut_selected',
  params: [
    {
      description: 'Which action triggered navigation to the canvases page',
      name: 'action_taken',
      required: true,
      type: 'enum',
      values: ['suggestion_selected', 'search_submitted'],
    },
    {
      description: 'The search term the user typed, normalized (trimmed and lowercased)',
      name: 'search_term',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
